(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("widget-bb-content", [], factory);
	else if(typeof exports === 'object')
		exports["widget-bb-content"] = factory();
	else
		root["widget-bb-content"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	};
	var __generator = (this && this.__generator) || function (thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * Turns querySelectorAll method from NodeList into Array so it is iterable
	 * @param {HTMLElement} element to perform querySelectorAll on
	 * @param {string} selector which is passed to querySelectorAll
	 * @returns {HTMLElement[]} elements array
	 */
	function querySelectorAll(element, selector) {
	    var nodeList = element.querySelectorAll(selector);
	    var nodeListArray = Array.prototype.slice.call(nodeList, 0);
	    return nodeListArray;
	}
	/**
	 * This method is invoked for the widget as of the render-bb-container render strategy
	 * @param {ContainerCreateInput} properties object containing domQueries, pubsub, refresh
	 * @return {Create} construction object for onBootstrap, onUpdate, and onRemove events
	 */
	function create(_a) {
	    var domQueries = _a.domQueries, refresh = _a.refresh;
	    /**
	     * Get widget chrome by instance name and return the widget body HTML element
	     * @param {string} name of the widget
	     * @return {HTMLElement} widget body HTML element
	     */
	    function getWidgetBody(name) {
	        return domQueries.getItemElementByName(name).children[0];
	    }
	    /**
	     * Bootstrapping of the widget which:
	     * - Changes empty images for placeholder images
	     * - Add the Lean Page wrapper class which adds placeholder for empty tags (with CSS)
	     * - Removes the ICE wrapper class which hides the content of the widget
	     * @param {Widget} props properties object containing the widget name, properties, etc
	     */
	    function onBootstrap(_a) {
	        var name = _a.name;
	        return __awaiter(this, void 0, void 0, function () {
	            var widgetBody;
	            return __generator(this, function (_b) {
	                // CONTENT-88 With a new custom render strategy this script can only be imported during design mode
	                if (window.BB.config.designmode !== 'true') {
	                    return [2 /*return*/];
	                }
	                widgetBody = getWidgetBody(name);
	                querySelectorAll(widgetBody, 'img')
	                    .filter(function (image) {
	                    // Use getAttribute as image.src will append host for absolute URL
	                    var src = image.getAttribute('src');
	                    // CONTENT-88 A new custom render strategy can inject the page config, removing the need for window.BB.config
	                    return !src || src === window.BB.config.apiRoot;
	                })
	                    .forEach(function (image) {
	                    // Use base64 of /catalog/widget-bb-content/media/transparent-320x180.png
	                    // This way the resource doesn't has to be loaded, which could cause a flicker when widget becomes visible again
	                    // A transparent image is used so the image sizing works similar to a real image
	                    image.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAC0CAYAAADl5PURAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAmhJREFUeJzt1DkBACAQwDAe/2ZPATIYmijo1D0zdwEEnd8BAL8YIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQJYBAlkGCGQZIJBlgECWAQJZBghkGSCQZYBAlgECWQYIZBkgkGWAQNYDbb4EQU3NydYAAAAASUVORK5CYII=';
	                    // Placeholder styling is done with CSS
	                    image.classList.add('widget-bb-content-lean-page-placeholder-image');
	                });
	                widgetBody.classList.add('widget-bb-content-lean-page');
	                widgetBody.classList.remove('be-ice-widget');
	                return [2 /*return*/];
	            });
	        });
	    }
	    /**
	     * Updating the widget should refresh the widget.
	     * This will trigger the widget to be re-rendered on the server.
	     */
	    function onUpdate(_a) {
	        var name = _a.name;
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_b) {
	                refresh(name);
	                return [2 /*return*/];
	            });
	        });
	    }
	    /**
	     * No cleanup has to happen on removing the widget.
	     */
	    function onRemove() {
	        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
	            return [2 /*return*/];
	        }); });
	    }
	    return {
	        onBootstrap: onBootstrap,
	        onUpdate: onUpdate,
	        onRemove: onRemove
	    };
	}
	exports.create = create;


/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// widget-bb-content/scripts/widget-bb-content.js